import { Center } from '@chakra-ui/react';
import { LoadingState } from '@main/complykit';
import { defaultAlertDialogContext, Page404 } from '@main/ui';
import { createRoute, createRouter } from '@tanstack/react-router';
import posthog from 'posthog-js';

import { rootRoute } from './routes/__root';
import { vendorQuestionnairesRoute } from './routes/questionnaires';
import { vendorLayout, vendorMain } from './routes/vendorToken';

const route404 = createRoute({
  getParentRoute: () => rootRoute,
  path: '*',
  component: Page404,
});

const routeTree = rootRoute.addChildren([
  vendorLayout.addChildren([vendorMain, vendorQuestionnairesRoute]),
  route404,
]);

export const router = createRouter({
  routeTree,
  scrollRestoration: true,
  defaultPendingComponent: () => (
    <Center h="100vh">
      <LoadingState />
    </Center>
  ),
  context: {
    dialog: defaultAlertDialogContext,
  },
});

router.subscribe('onLoad', () => {
  posthog.capture('$pageview');
  router.options.context.dialog.closeDialog();
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
